import { createSelector } from '@reduxjs/toolkit';
import modalsSelector from './modals';

const addLimitModalSelector = createSelector(modalsSelector, (modals) => modals.addLimit);

export default addLimitModalSelector;
